import h from "../core/createElement";
import { byteMetter, time_metter } from "../utils";
import Btn from "./btn";


const ico_type = {
    "application/atom+xml": "assets/image/file-xml.svg",
    "application/pdf": "assets/image/file-pdf.svg",
    "text/html": "assets/image/file-html.svg",
    "text/csv": "assets/image/file-csv.svg",
    "application/vnd.ms-excel": "assets/image/file-xls.svg",
};

export default function FileReponseTestCard({ data: { filename, size, content_type, exec_time, blob_url }, removeCard }) {

    const _size = byteMetter(size), e_time = time_metter(exec_time);

    const
        download_file = () => {
            const a = h('a', { style: "display:none;", download: filename, href: blob_url });
            document.body.appendChild(a);
            a.click();
            a.remove();
        },
        view_file = () => {
            window.open(blob_url, "_blank");
        }

    return (
        <article class="card file-response">
            <img src={ico_type[content_type]} class="file-icon" />
            <div class="file-info flex-column">
                <span class="title">{filename}</span>

                <div class="flex justify-space-between">
                    <span class="labels">{e_time.time}{e_time.unity}</span>
                    <span class="labels">{_size.total.toFixed(2) + _size.unity}</span>
                </div>

                <div class="flex justify-end">
                    <Btn icon="assets/image/trash.svg" color="red" onClick={removeCard} />

                    {["application/pdf", "text/html"].includes(content_type) ? <Btn icon="assets/image/eye.svg" color="dark-gray" onClick={view_file} /> : ""}

                    <Btn icon="assets/image/download-simple.svg" color="blue" onClick={download_file} />
                </div>
            </div>
        </article>
    );
};